import React from 'react';

import { Table, Box } from 'vindi-ds-components';
import tokens from 'vindi-ds-tokens';

const EmptyCard = () => (
  <Box display='flex' justifyContent='center' bgcolor={tokens.color.prsm.neutral['000'].value}>
    <Table.EmptyState
      texts={{
        headerText: 'Não há itens registrados ainda.',
        bodyText: 'Quando houver itens registrados, eles serão exibidos aqui.',
      }}
    />
  </Box>
);

export default EmptyCard;
